import { Component } from '@angular/core';
import { InsightsService } from '../insights.service';
import { ReportDelivery } from 'src/app/models/insights';
import { NotificationService } from 'src/app/shared/notification.service';
import { AuthService } from 'src/app/auth.service';

@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.less']
})
export class ReportsComponent {

  reports: ReportDelivery[] = [];
  isLoading: boolean = true;
  constructor(private insightsService: InsightsService, private notification: NotificationService, public auth: AuthService) {}


  ngOnInit() {
    this.insightsService.availableReports().subscribe({
      next: (data: ReportDelivery[]) => {
        this.reports = data;
      },
      error: (error) => {
        this.notification.handleError('Error fetching available reports.', error);
      },
      complete: () => {
        this.isLoading = false;
      }
    });
  }

  public requestReport(reportId: number) {
    this.isLoading = true;
    this.insightsService.requestReport(reportId).subscribe({
      next: (data: ReportDelivery[]) => {
        this.reports = data;
        this.notification.showSuccess('Report requested successfully. You will receive it via email shortly.');
      },
      error: (error) => {
        this.notification.handleError('There was an error requesting the report. Please try again later.', error);
      },
      complete: () => {
        this.isLoading = false;
      }
    });
  }

  public isRequestDisabled(report: ReportDelivery): boolean {
    if (!report.dtScheduled) return false;
    const now = new Date();
    const scheduledDate = new Date(report.dtScheduled + 'Z');
    return (now.getTime() - scheduledDate.getTime()) < 15 * 60 * 1000;
  }

    crossAuthData: any = null;

  navigateToDataGate(): void {
    this.auth.generateCrossAuthToken().subscribe({
      next: (data) => {
        this.crossAuthData = data;

        window.open(`${this.crossAuthData.redirect_url}?cross_auth_token=${this.crossAuthData.cross_auth_token}`, "_blank");
      },
      error: (err) => {
        console.error('Failed to generate cross-auth token:', err);
        alert('Failed to generate authentication for Website 2');
      }
    });
  }

}